export default __webpack_public_path__ + "static/media/postpo.e8ac3777.jpg";